// removed by extract-text-webpack-plugin
module.exports = {"fadeInRight":"index__fadeInRight___1I3yv"};


//////////////////
// WEBPACK FOOTER
// ./src/index.scss
// module id = 200
// module chunks = 0